import React from "react";
import { Grid, Typography, Button, Box } from '@mui/material';
import { ElfsightWidget } from 'react-elfsight-widget'

export default function ReviewBanner() {

    return(
        <Grid container sx={{flex: 1, width: '100%', justifyContent: 'center', backgroundColor: 'rgb(22, 161, 216)'}} p={{md: 3, xs: 1}}>
            <Typography variant="h4" component="div" sx={{textAlign: 'center', marginBottom: 0, color: 'white'}} fontWeight={'bold'}>
                WHAT OUR CUSTOMERS SAY
            </Typography>
            <Grid item size={12} sx={{ width: '100%' }} p={2}>
            <Box sx={{backgroundColor: '#1a1a1a', borderRadius: 5}} p={{md: 3, xs: 1}}>
                <ElfsightWidget widgetId="b63ef323-955c-4664-9ad1-97a6cb5473d1"/>
            </Box>
            
            </Grid>
        </Grid>
    )
}